import React from 'react'

function Third() {
  return (
<section className="third">
    <div className="container">
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <img src="/logo.png" alt="Crazy Monkey Slot Logo"/>
            </div>
            <div className="right-col">
                <p className="text">
                    Niille, jotka etsivät visuaalisesti houkuttelevaa kokemusta, Crazy Monkey Slot tarjoaa kiehtovia pelisymboleja, jotka tekevät jokaisesta pyöräytyksestä nautinnollisen. Pelin kirkkaat värit herättävät jokaisen käyttöliittymän elementin eloon, luoden elävän ja viihdyttävän ilmapiirin. Tämä ilmainen sosiaalinen kasino tarjoaa mahdollisuuden kokea kasinotyylistä jännitystä täysin viihdetarkoituksiin ilman taloudellista riskiä.
                </p>
            </div>
        </div>
        <p className="text text-md">
            Crazy Monkey Slot tarjoaa täydellisen ja unohtumattoman pelikokemuksen. Sukella sosiaalisen kasinopelaamisen lumoavaan maailmaan ja nauti jokaisesta hetkestä. Sekä mobiililaitteilla että tietokoneilla yhteensopiva peli on aina ja kaikkialla käytettävissäsi. Crazy Monkey Slot tarjoaa ilmaista viihdettä, joka yhdistää ilon ja jännityksen ilman, että sinun tarvitsee poistua kotoasi.
        </p>
    </div>
</section>


  )
}

export default Third